var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTune = function SvgTune(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 20.75v-5.5h1.5v2h8v1.5h-8v2zm-8-2v-1.5h5.5v1.5zm4-4v-2h-4v-1.5h4v-2h1.5v5.5zm4-2v-1.5h9.5v1.5zm4-4v-5.5h1.5v2h4v1.5h-4v2zm-12-2v-1.5h9.5v1.5z"
  })));
};
export default SvgTune;